/* Who the Tokenwise/Stigg UI applies to (OPSS-55). */

const ARCHIVED_STIGG_CUSTOMER_ID_PREFIX = "archived_";

/** True when the id identifies an active Stigg customer — ported from studio-web's
 *  useIsStiggUser. False for missing ids and the `archived_<orig>` sentinel. No active
 *  Stigg customer ⇒ don't show any billing UI. */
export function isActiveStiggCustomerId(stiggCustomerId?: string): boolean {
  return (
    !!stiggCustomerId &&
    !stiggCustomerId.startsWith(ARCHIVED_STIGG_CUSTOMER_ID_PREFIX)
  );
}

/** AI21 employees are always pro — never gated, never shown trial/paywall UI. */
export function isAi21User(email?: string): boolean {
  return !!email && email.toLowerCase().endsWith("@ai21.com");
}
